export const PROFILE_STUDENT_RESUME_REMOVE_REQUEST = 'profile/student-resume-remove-request'
export const PROFILE_STUDENT_RESUME_REMOVE_SUCCESS = 'profile/student-resume-remove-success'
export const PROFILE_STUDENT_RESUME_REMOVE_FAILED = 'profile/student-resume-remove-failed'
